const sceneQuestions = [
  {
    page: 'homeFurnishing',
    statusKey: 'house',
  },
  {
    page: 'eatingIn',
    statusKey: 'food',
  },
  {
    page: 'eatingOut',
    statusKey: 'eatout',
  },
  {
    page: 'transport',
    statusKey: 'transport',
  },
  {
    page: 'holidays',
    statusKey: 'holiday',
  },
  {
    page: 'treats',
    statusKey: 'treat',
  },
  {
    page: 'personal',
    statusKey: 'personal',
  },
];

const sceneQuestionPages = _.map(sceneQuestions, (q) => q.page);

const allPages = [
  'welcome',
  'cohabiting',
  // 'location',
  ...sceneQuestionPages,
  'loading',
  'results',
  'disclaimer-and-assumptions',
];

export default {
  state: {
    sceneQuestions,
    currentPageIndex: 0,
    lastVisitedPageIndex: null,
    showForeground: true,
    hasSceneAnimations: true,
    isAnimating: false,
  },
  getters: {
    currentPage: state => allPages[state.currentPageIndex],
    isOnPage: (state, getters) => pageName => getters.currentPage === pageName,
    isOnQuestionPage: (state, getters) => _.includes(['cohabiting', ...sceneQuestionPages], getters.currentPage),
  },
  mutations: {
    goToNextPage(state) {
      state.lastVisitedPageIndex = state.currentPageIndex;
      state.currentPageIndex++;
    },
    goToPreviousPage(state) {
      state.lastVisitedPageIndex = state.currentPageIndex;
      state.currentPageIndex--;
    },
    goToPage(state, pageName) {
      // First check whether user is on Disclaimer page, as it is the only page which is not accessed sequentially,
      // and as such can trap the user by becoming both the current and previous page index on double-clicks.
      if (allPages[state.currentPageIndex] !== 'disclaimer-and-assumptions') {
        state.lastVisitedPageIndex = state.currentPageIndex;
      }
      state.currentPageIndex = allPages.indexOf(pageName);
    },
    goToLastVisitedPage(state) {
      const tempLastVisitedPageIndex = state.lastVisitedPageIndex;
      state.lastVisitedPageIndex = state.currentPageIndex;
      state.currentPageIndex = tempLastVisitedPageIndex;
    },
    setIsAnimating(state, status) {
      state.isAnimating = status;
    },
  },
}
